import {
    WorkTimeReportQueryParams,
    WorkTimeReportRowDto,
    WorkTimeReportSalaryDto,
} from "../models/reporting/workTimeReport";
import { SalaryItem } from "../models/workHourSalary/salaryItem";
import { WorkHourSalaryCalculateParams } from "../models/workHourSalary/workHourSalaryCalculateParams";
import { apiCall } from "./apiClient";

export interface SalariesParams {
    salaryPeriodId: string;
    employeeGroupId: string;
}

export const getWorkHourSalaries = (
    params: SalariesParams,
    signal?: AbortSignal
) => {
    return apiCall<SalaryItem[]>("WorkHourSalary", "GET", params, signal);
};

export const getWorkTimeReportData = (
    params: WorkTimeReportQueryParams,
    signal?: AbortSignal
) => {
    return apiCall<WorkTimeReportRowDto[]>(
        "WorkHourSalary/WorkTimeReport",
        "GET",
        params,
        signal
    );
};

export const getWorkTimeReportSalaries = (
    params: WorkTimeReportQueryParams,
    signal?: AbortSignal
) => {
    return apiCall<WorkTimeReportSalaryDto[]>(
        "WorkHourSalary/WorkTimeReport/salaries",
        "GET",
        params,
        signal
    );
};

export const calculateWorkTimeReportData = (
    params: WorkHourSalaryCalculateParams,
    signal?: AbortSignal
) => {
    return apiCall<WorkTimeReportSalaryDto[]>(
        "WorkHourSalary/WorkTimeReport/calculate",
        "POST",
        params,
        signal
    );
};
